export const css = {
	root: '_2-A-3ph4',
	tabTitle: '_2RxTI7W6',
	title: '_1FTN8Z2K',
	titleClosed: 'ciN2-Kka',
	titleOpen: '_2K2FeAGD',
	imgTitle: '_2LB1u0XI',
	bookIcon: '_3SNggJkY',
	lockIcon: '_1qCaHMx7',
	' _key': 'explore-view/content-order'
};

export default css;
